import Close from '@components/icons/Close/Close'
import Button from '@components/ui/ButtonV2/Button'
import Checkbox from '@components/ui/inputs/Checkbox'
import FormControl from '@components/ui/inputs/FormControl'
import { useDisclosure } from '@lib/helpers/useDisclosure'
import useCustomerSegments from '@lib/hooks/useCustomerSegments'
import useGetCustomerGroups from '@lib/hooks/useGetCustomerGroups'
import clsx from 'clsx'
import React, { FC, PropsWithChildren, useState } from 'react'
import { Dialog, Modal, ModalOverlay } from 'react-aria-components'
import s from '../M61ProfileView/M61ProfileView.module.scss'

interface Props {
  currentGroup: {
    id: string
    name: string
  }
  isLoading: boolean
}
type NativeAttrs = Omit<React.HTMLAttributes<HTMLDivElement>, keyof Props>

export type AccountTypeFormProps = Props & NativeAttrs

const AccountTypeForm = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<AccountTypeFormProps>
>(({ className, children, isLoading, currentGroup, ...props }, ref) => {
  const { isOpen, open, close } = useDisclosure()

  const { customerGroups } = useGetCustomerGroups()

  const [selectedGroup, setSelectedGroup] = useState<string | null>(
    currentGroup?.id,
  )

  const [step, setStep] = useState(1)

  const handleClose = () => {
    setStep(1)
    close()
  }

  const { customerSegment: segmentRequest, requestNewCustomerSegment } =
    useCustomerSegments()

  if (!currentGroup) return null

  // @TODO: Should check whether company information is already added to account

  return (
    <div className={clsx(s.customInput, s.formInputWrapper)}>
      <div className={s.customInput__label}>Account Type</div>
      <div className={s.customInput__input}>
        <div className={s.flex__split}>
          <>
            {isLoading ? (
              <div
                className={s.skeleton}
                style={{ width: '96px', height: '19.2px' }}
              ></div>
            ) : (
              <>
                {currentGroup.name}
                {/* <a onClick={open}>Edit</a> */}
              </>
            )}
          </>
        </div>
      </div>

      <ModalOverlay
        isDismissable
        isOpen={isOpen}
        onOpenChange={(isOpen) => (isOpen ? open() : handleClose())}
        className={s.overlay}
      >
        <Modal className={s.modal}>
          <Dialog>
            <div className={s.close}>
              <button
                className={s.closeButton}
                type="button"
                onClick={handleClose}
              >
                <Close className="h-6 w-6" />
              </button>
            </div>
            <div className={s.newHeadline}>ACCOUNT TYPE</div>
            {step === 1 ? (
              <>
                {/* segmentRequest?.groupStatus === 'AWAITING_APPROVAL' */}
                {true && (
                  <div className={s.infoUsp}>
                    <div className={s.text}>
                      <p>
                        You have requested to change your group to{' '}
                        <b>
                          A&D
                          {/* {customerGroups &&
                            customerGroups.find(
                              (group) =>
                                group.id === segmentRequest.requestedGroup,
                            ).name} */}
                        </b>
                        <br />
                        We strive to approve your request within 48 hours.
                      </p>

                      <p>
                        Please note that you are unable to request a new group
                        until your current request has been approved.
                      </p>
                    </div>
                  </div>
                )}
                {customerGroups &&
                  customerGroups.map((customerGroup) => (
                    <div className={s.modalSection} key={customerGroup.id}>
                      <div className={s.accountTypeWrapper}>
                        <FormControl
                          className={s.formInputWrapper}
                          layout="horizontal"
                        >
                          <Checkbox
                            value={customerGroup.id}
                            checked={selectedGroup === customerGroup.id}
                            onChange={() => setSelectedGroup(customerGroup.id)}
                          />
                          <FormControl.Caption>
                            {customerGroup.name}
                          </FormControl.Caption>
                        </FormControl>
                        <div className={s.type__description}>
                          {customerGroup.description}
                        </div>
                      </div>
                    </div>
                  ))}
              </>
            ) : (
              <Step2
                selectedGroupName={
                  customerGroups.find((group) => group.id === selectedGroup)
                    .name
                }
              />
            )}
            <div className={s.modalSection}>
              <Button
                className={s.button}
                size="small"
                variant="secondary"
                onClick={() => setStep(2)}
                // onClick={() => requestNewCustomerSegment(selectedGroup)}
                disabled={
                  selectedGroup === currentGroup.id ||
                  segmentRequest?.groupStatus === 'AWAITING_APPROVAL'
                }
              >
                Continue
              </Button>
            </div>
          </Dialog>
        </Modal>
      </ModalOverlay>
    </div>
  )
})

const Step2: FC<{
  selectedGroupName: string
}> = ({ selectedGroupName }) => {
  return (
    <div className={s.modalSection}>
      <p>
        We need a bit more information to change your account type to{' '}
        <b>{selectedGroupName}</b>. Please fill out the form below in order to
        start the process.
      </p>
    </div>
  )
}

AccountTypeForm.displayName = 'AccountTypeForm'
export default AccountTypeForm
